import { useEffect, useState } from 'react';

type Item<T> = T & { id: string };
type Add<T> = (info: T) => void;
type Update<T> = (info: T) => void;
type Rm = (id: string) => void;

type UseListRes<T> = [
	Array<Item<T>>,
	number,
	{
		addItem: Add<Item<T>>;
		updateItem: Update<Item<T>>;
		rmItem: Rm;
	},
];

const useCustomList = <T extends { id: string }>({
	defaultList,
}: {
	defaultList: Array<T>;
}): UseListRes<T> => {
	const [list, setList] = useState<Array<Item<T>>>([]);
	const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    setList(defaultList);
    setTotal(defaultList.length);
  }, [defaultList])

	const add: Add<Item<T>> = (item) => {
		setList((prev) => [item, ...prev]);
		setTotal(total + 1);
	};

	const rm: Rm = (id) => {
		setList((prev) => prev.filter((item) => item.id !== id));
		setTotal(total - 1);
	};

	const update: Update<Item<T>> = (upItem) => {
		setList((prev) => {
			return prev?.map((item) => (item.id === upItem.id ? upItem : item));
		});
	};

	return [
		list,
		total,
		{ addItem: add, updateItem: update, rmItem: rm },
	];
};

export default useCustomList;
